export const defaultColors = [
  "#6E0E0A",
  "#D74E09",
  "#F2BB05",
  "#72B01D",
  "#3F7D20",
  "#119DA4",
  "#00B4DD",
  "#124E78",
  "#454955",
  "#262528",
];

export const getUnitColor = (dataKey, index) => {
  switch (dataKey) {
    case "solarGenerated": {
      return "#24A21A";
    }
    case "gridConsumed": {
      return "#808080";
    }
    case "solarFeedIn": {
      return "#EA7624";
    }
    case "solarReturned": {
      return "#EA7624";
    }
    case "solarConsumed": {
      return "#FFB50A";
    }
    case "netConsumed": {
      return "#000000";
    }
    default: {
      return defaultColors[index % 9];
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/UnitsAndKeys/getUnitColor.js